import LegacyButton from "legacy/LegacyButton"
import PropTypes from "prop-types"
import React from "react"

class UnpaidAlert extends React.Component {
  constructor(props) {
    super(props)

    this.fireAmplitudeEventAndRedirect =
      this.fireAmplitudeEventAndRedirect.bind(this)
  }

  fireAmplitudeEventAndRedirect() {
    // Note: Amplitude is loaded globally, not via an import
    Amplitude.trackEvent("marina_dashboard:unpaid_customers_pressed", {
      marina: this.props.marinaSlug,
      experience_name: "marina_dashboard",
    })
    location.href = this.props.unpaidRoute
  }

  // Helper method to handle pluralization
  pluralize(word, count) {
    return count === 1 ? word : `${word}s`
  }

  render() {
    return (
      <div className="alert alert-danger center-text mb-3">
        <strong>Heads up!</strong> You have {this.props.unpaidCount}{" "}
        <strong>Unpaid</strong> {this.pluralize("boat", this.props.unpaidCount)}{" "}
        to collect from today!
        <LegacyButton
          type="danger"
          className="center mt-2.5 flex"
          onClick={this.fireAmplitudeEventAndRedirect}
        >
          Unpaid Customers
        </LegacyButton>
      </div>
    )
  }
}

UnpaidAlert.propTypes = {
  unpaidCount: PropTypes.number.isRequired,
  marinaSlug: PropTypes.string.isRequired,
  unpaidRoute: PropTypes.string.isRequired,
}

export default UnpaidAlert
